"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var BrandedServiceLink_1 = __importDefault(require("shared/hds/BrandedServiceLink"));
var InsightAvailable = function (_a) {
    var _b = __read(_a.notifications, 1), notif = _b[0];
    if (!notif.service)
        return null;
    // return <>The pricing insights you requested for <ServiceAvatar service={notif.service} /> are now available.</>;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["The pricing insights you requested for ", (0, jsx_runtime_1.jsx)(BrandedServiceLink_1.default, { service: notif.service }), " are now available.", ' ', "We sent the report to your email."] }));
};
exports.default = InsightAvailable;
